// JS Libs
import Vue from "vue";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import "../../../node_modules/bootstrap-sass/assets/javascripts/bootstrap.min";
import "../../../node_modules/inputmask/dist/jquery.inputmask.bundle";
import "select2";
import "magnific-popup";
import "jquery-touchswipe";

import "../../../vendor/yiisoft/yii2/assets/yii.js";
import "../../../vendor/yiisoft/yii2/assets/yii.activeForm.js";
import "../../../vendor/yiisoft/yii2/assets/yii.captcha.js";
import "../../../vendor/yiisoft/yii2/assets/yii.gridView.js";
import "../../../vendor/yiisoft/yii2/assets/yii.validation.js";
import "../../../vendor/bower-asset/yii2-pjax/jquery.pjax";

// Sentry
import './js/sentry';

// JS

import "./js/helpers";
import "./js/store";
import "./js/api.js";
import "./js/offline.js";
import "./js/app.js";
import "./js/common.js";
import "./js/comments.js";
import "./js/events.js";
import "./js/event.js";
import "./js/nmo.js";
import "./js/lections.js";
import "./js/main-page";
import "./js/show.lections.js";
import "./js/stream.js";
import "./js/stream.admin.js";
import "./js/stream.lector.js";
import "./js/stream-join.js";
import "./js/test.js";
import "./js/task.js";
import "./js/registration.js";
import "./js/lector-list.js";
import "./js/lector.js";
import "./js/partner.js";
import "./js/partner-list.js";
import "./js/organization.js";
import "./js/organization-list.js";
import "./js/create-certificate.js";
import "./js/order-certificate.js";
import "./js/settings-account.js";
import "./js/cycle.js";
import "./js/settings-organization.js";
import "./js/settings-subscribe.js";
import "./js/exam.js";
import "./js/select2.ru.js";
import "./js/share.js";
import "./js/appear.js";
import "./js/stream.online.js";
import "./js/course-landing.js";
import "./js/questionnaire.js";
import "./js/notifications";
import "./js/notify-bell";
import "./js/notify-bell-mobile";
import "./js/course-payment";
import "./js/pro-payment";
import "./js/event-list";

import "./js/fast-registration";
import "./js/login";
import "./js/recover-password-success";
import "./js/recover-password";
import "./js/ui";

// Style

import "./scss/template.scss";
